import {Component} from 'react'
import PropTypes from 'prop-types'
import {getUserPermissions, getUserRoles, isAuthenticated, subscribe, unsubscribe} from "../../services/AuthServices"

class WithAuthentication extends Component {
    state = {
        isAuthenticated: isAuthenticated(),
        userRoles: getUserRoles(),
        userPermissions: getUserPermissions()
    }

    componentDidMount() {
        subscribe(this._handleAuthChange)
    }

    componentWillUnmount() {
        unsubscribe(this._handleAuthChange)
    }

    _handleAuthChange = () => {
        this.setState({
            isAuthenticated: isAuthenticated(),
            userRoles: getUserRoles(),
            userPermissions: getUserPermissions()
        })
    }

    render() {
        return this.props.children(this.state)
    }
}

WithAuthentication.propTypes = {
    children: PropTypes.func.isRequired,
}

export default WithAuthentication
